import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/mails.vue
var o = {
	name: "DtIconMails",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--mails"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Mails",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 13 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4.5 2.5A.5.5 0 0 0 4 3v.2l3.283 1.748a.458.458 0 0 0 .433 0L11 3.2V3a.5.5 0 0 0-.5-.5h-6Zm7.5.99V3a1.5 1.5 0 0 0-1.5-1.5h-6A1.5 1.5 0 0 0 3 3v4.5A1.5 1.5 0 0 0 4.5 9h6A1.5 1.5 0 0 0 12 7.5V3.49Zm-1 .843-2.817 1.5a1.46 1.46 0 0 1-1.366 0l-.002-.002L4 4.333V7.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V4.333ZM1.5 3.5A.5.5 0 0 1 2 4v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1h-7C1.674 11 1 10.326 1 9.5V4a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=mails.js.map